import { Component, OnInit } from '@angular/core';
import { Auth } from 'src/app/models/auth';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ParametrosDataService } from "src/app/services/parametros-data.service";
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { BooleanConverter } from "src/app/shared/helpers/converters/boolean-converter";

import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { TransactionService } from 'src/app/services/transaction.service';
import { SolicitacoesRequestModel } from 'src/app/models/request/solicitacoes-request-model';
import { SolicitacoesResponseModel } from 'src/app/models/response/solicitacoes-response-model';
import { IntencaoDepositoResponseModel } from 'src/app/models/response/intencao-deposito-response-model';
import { IntencaoConsultaResponseModel } from 'src/app/models/response/intencao-consulta-response-model';
import { DepositoViaBoletoRequestModel } from 'src/app/models/request/deposito-via-boleto-request-model';
import { DepositoService } from 'src/app/services/deposito.service';
import { GerarBoletoCadastro } from 'src/app/models/gerar-boleto-cadastro';
import { VisualizarBoletoService } from '../../../visualizar-boleto/visualizar-boleto.service';
import { TipoDepositoEnum } from 'src/app/shared/enums/tipo-deposito-enum';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { MASKS } from 'ng-brazil';

@Component({
  selector: 'app-boleto',
  templateUrl: './boleto.component.html',
  styleUrls: ['./boleto.component.css']
})
export class BoletoComponent implements OnInit {

  public currentUser: Auth;
  public solicitacoes: SolicitacoesResponseModel[] = [];
  public message = '';
  public confirmacaoDeposito: IntencaoDepositoResponseModel = null;
  public informativoDeposito = new IntencaoConsultaResponseModel();
  public MASKS = MASKS;
  private temEndereco: boolean = false;
  private temDadoBancario: boolean = false;

  constructor(
    private transactionservice: TransactionService,
    private authenticationService: AuthenticationService,
    private alertService: NewAlertService,
    private depositoService: DepositoService,
    private visualizarBoletoService: VisualizarBoletoService,
    private parametrosDataService: ParametrosDataService,
    private router: Router
  ) { }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.BuscarSolicitacoes();
    this.loadParametros();
    this.message = '';
  }

  private BuscarSolicitacoes() {
    const solicitacoesRequestModel = new SolicitacoesRequestModel();
    solicitacoesRequestModel.ContaId = this.currentUser.token.accountId;
    solicitacoesRequestModel.Cancelados = false;
    solicitacoesRequestModel.Processados = false;
    solicitacoesRequestModel.SolicitacaoSemDetalhamento = true;
    solicitacoesRequestModel.SolicitacaoSemPedido = true;
    solicitacoesRequestModel.TipoDeposito = TipoDepositoEnum.Boleto;
    solicitacoesRequestModel.TipoSolicitacao = 'D';

    this.transactionservice.BuscarSolicitacoes(solicitacoesRequestModel).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {

          this.solicitacoes = response.result;
        } else {
          this.alertService.error(response.message);
        }
      },
      error => {
        this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
      }
    );
  }

  loadParametros() {
    const parametros = this.parametrosDataService.currentParametrosValue;
    if (parametros) {
        if (parametros[ParametrosKey.temEndereco]) {
            this.temEndereco = BooleanConverter.getBoolean(
                parametros[ParametrosKey.temEndereco]
            );
        }

        if (parametros[ParametrosKey.temDadoBancario]) {
            this.temDadoBancario = BooleanConverter.getBoolean(
                parametros[ParametrosKey.temDadoBancario]
            );
        }
    }
  }

  public DepositarViaBoleto(valor: string) {
    valor = valor.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();
    let formValid = true;

    if (!valor || +valor == 0) {
      this.message = 'Preencha o valor';
      formValid = false;
    }

    if(!this.temDadoBancario) {
      this.alertService.error("Para gerar depósitos com boleto é necessário ter uma conta bancária cadastrada! Para cadastrar navegue até Administrativo > Dados bancários");
      this.message = 'Dado bancário não encontrado!';
      formValid = false;
    }

    if(!this.temEndereco) {
      this.alertService.error("Para gerar depósitos com boleto é necessário ter um endereço cadastrado! para cadastrar navegue até Administrativo > Dados da empresa");
      this.message = 'Você ainda não cadastrou um endereço!';
      formValid = false;
    }

    if (formValid) {
      const depositoViaBoletoRequestModel = new DepositoViaBoletoRequestModel();
      depositoViaBoletoRequestModel.contaGuid = this.currentUser.token.accountId;
      depositoViaBoletoRequestModel.valor = +valor;
      depositoViaBoletoRequestModel.cedenteGuid = this.currentUser.token.assignorGuid;
      depositoViaBoletoRequestModel.gestorGuid = this.currentUser.token.userReferenceId;

      this.transactionservice.CriarDepositoViaBoleto(depositoViaBoletoRequestModel).subscribe(
        response => {
          if (response.status === ApiError.Sucesso) {


            this.GerarBoleto(response.result, +valor);
          } else {
            this.alertService.error(response.message);
          }
        },
        error => {
          this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
        }
      );
    }
  }

  public CancelarDeposito(depositoID: string) {
    this.transactionservice.CancelarDeposito(depositoID, this.currentUser.token.userReferenceId).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.alertService.success('Intenção de depósito cancelada com sucesso');
          this.BuscarSolicitacoes();
        } else {
          this.alertService.error(response.message);
        }
      },
      error => {
        this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
      }
    );
  }

  private GerarBoleto(intencaoDepositoGuid: string, valor: number) {
    this.depositoService.generateBoleto(intencaoDepositoGuid, new GerarBoletoCadastro(valor, null), this.currentUser.token.assignorGuid).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.visualizarBoletoService.arquivoBase64 = response.result.pdf;

          const options = {
            keepAfterRouteChange : true
          };

          this.alertService.notificationInfo('Intenção de depósito', 'Registrada com sucesso, assim que o pagamento do boleto for identificado vamos creditar o valor na conta da cedente. Obrigado!', options);

          this.router.navigate(['portal/boleto']);
        } else {
          this.alertService.error(response.message);
        }
      }, error => {
        this.alertService.error('Ocorreu um erro ao gerar boleto');
      }
    );
  }

  orderBy(collumnName: string, sortOrder: boolean) {
    this.solicitacoes.sort((a, b) => {
      const dftl = sortOrder ? Number.MAX_VALUE : -Number.MAX_VALUE;
      const aVal = (a[collumnName] === null
        ? dftl
        : a[collumnName]
      ).toString();
      const bVal = (b[collumnName] === null
        ? dftl
        : b[collumnName]
      ).toString();
      let result = aVal.localeCompare(bVal, undefined, { numeric: true });
      if (sortOrder) {
        result = bVal.localeCompare(aVal, undefined, { numeric: true });
      }

      return result;
    });

  }

  openBoleto(boleto: string) {
    this.visualizarBoletoService.arquivoBase64 = boleto;
    this.router.navigate(['portal/boleto']);
  }

}
